module.exports = __webpack_public_path__ + "img/12.1.9d38ea15.jpg";